import { render, staticRenderFns } from "./ConnectionStateIndicator.vue?vue&type=template&id=b5bfe7c4&scoped=true&"
import script from "./ConnectionStateIndicator.vue?vue&type=script&lang=js&"
export * from "./ConnectionStateIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionStateIndicator.vue?vue&type=style&index=0&id=b5bfe7c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bfe7c4",
  null
  
)

export default component.exports